import IFormulaBase from "./formulaBase";
import GLRangeFormula from "./glRangeFormula";
import {GLBalanceFormula} from "./glBalanceFormula";
import TPBalanceFormula from "./tpBalanceFormula";

export default class FormulaFactory {
  constructor(private token: string) {}

  getFormulaInstance(formula: string): IFormulaBase {
    const glRangeFormula = new GLRangeFormula(this.token);
    const glBalanceFormula = new GLBalanceFormula(this.token);
    const tpBalanceFormula = new TPBalanceFormula(this.token);
    return glRangeFormula.parse(formula) || glBalanceFormula.parse(formula) || tpBalanceFormula.parse(formula);
  }
}
